import {
  AUTHORIZED_MODULE,
  NOTIFICATION,
  SYSTEM_MODULE,
  APPLICATION_MODULE,
  REFERENCE_INFORMATION_MODULE,
  REGION_REGISTRY_MODULE,
  INTEGRATION_MODULE,
  USER_MODULE,
  REPORT_MODULE,
  SETTINGS_MODULE,
  WAY_BILL_MODULE,
  VISITS_MODULE,
  VEHICLES_REGISTRY_MODULE,
  DRIVER_LOG_MODULE,
  VIOLATIONS_MODULE,
  INFORMATION_SCREEN_WRAPPER,
  CENTRIFUGE_MODULE,
  FILTER_TEMPLATE_MODULE, ROLLBACK_VERSION_MODULE, APPLICANT_MODULE, INFORMATION_LOG_MODULE,
} from '../configs/moduleNames';

import System from './System';
import Authorized from './Authorized';
import Notifications from './Notifications';
import Application from './Application';
import ReferenceInformation from './ReferenceInformation';
import RegionRegistry from './RegionRegistry';
import Integration from './Integration';
import WebSocket from './WebSocket';
import User from './User';
import Report from './Report';
import Settings from './Settings';
import Waybill from './Waybill';
import Visits from './Visits';
import VehicleRegistry from './VehicleRegistry';
import DriverLog from './DriverLog';
import ViolationsPage from './Violations';
import InformationScreenWrapper from './InformationScreenWrapper';
import Centrifuge from './Centrifuge';
import FilterTemplate from './FilterTemplate';
import RollbackVersion from './RollbackVersion';
import Applicant from './Applicant';
import InformationLog from './InformationLog';

const modules = {
  [SYSTEM_MODULE]: System,
  [AUTHORIZED_MODULE]: Authorized,
  [NOTIFICATION]: Notifications,
  [APPLICATION_MODULE]: Application,
  [REGION_REGISTRY_MODULE]: RegionRegistry,
  [REFERENCE_INFORMATION_MODULE]: ReferenceInformation,
  [REPORT_MODULE]: Report,
  [INTEGRATION_MODULE]: Integration,
  [USER_MODULE]: User,
  [SETTINGS_MODULE]: Settings,
  [WAY_BILL_MODULE]: Waybill,
  [VISITS_MODULE]: Visits,
  [VEHICLES_REGISTRY_MODULE]: VehicleRegistry,
  [DRIVER_LOG_MODULE]: DriverLog,
  [INFORMATION_LOG_MODULE]: InformationLog,
  [APPLICANT_MODULE]: Applicant,
  [VIOLATIONS_MODULE]: ViolationsPage,
  [INFORMATION_SCREEN_WRAPPER]: InformationScreenWrapper,
  [CENTRIFUGE_MODULE]: Centrifuge,
  [FILTER_TEMPLATE_MODULE]: FilterTemplate,
  [ROLLBACK_VERSION_MODULE]: RollbackVersion,
};

export default modules;
